export default {
  GOOGLE_CALENDAR: {
    HEADER: 'Google Calendar',
    CONNECT: {
      TITLE: 'Connect your Google Calendar',
      DESCRIPTION: 'View your events, share availability with teammates, and create appointments directly from conversations.',
      BUTTON: 'Connect Google Account',
      CONNECTING: 'Connecting...',
      MODAL: {
        TITLE: 'Connect Google Calendar',
        DESCRIPTION: 'The following permissions will be requested on your Google account:',
        PERMISSIONS: [
          'Read your calendar events',
          'Create and edit events on your behalf',
          'Create and manage your calendars',
          'View your availability (free/busy)',
        ],
        CONFIRM: 'Connect with Google',
        CANCEL: 'Cancel',
      },
    },
    DISCONNECT: {
      BUTTON: 'Disconnect',
      CONFIRM: 'Are you sure you want to disconnect your Google Calendar?',
    },
    RECONNECT: {
      BUTTON: 'Reconnect',
    },
    CONNECTED_AS: 'Connected as',
    EVENTS: {
      TITLE: 'My Calendar',
      EMPTY: 'No events for this period',
      NEW_EVENT: 'New Event',
      ALL_DAY: 'All day',
    },
    CALENDAR: {
      WEEK: 'Week',
      MONTH: 'Month',
      AGENDA: 'Agenda',
    },
    AGENDA: {
      TITLE: 'Upcoming',
      EMPTY: 'No upcoming events',
      TODAY: 'Today',
      TOMORROW: 'Tomorrow',
    },
    CALENDARS: {
      TITLE: 'My calendars',
      SUBSCRIBED: 'subscribed',
      SUBSCRIBE_BUTTON: 'Add another calendar',
      SUBSCRIBE_PLACEHOLDER: 'email@example.com or calendar ID',
      SUBSCRIBE_ADD: 'Add',
      SUBSCRIBE_MODAL_TITLE: 'Add another calendar',
      SUBSCRIBE_MODAL_SUBTITLE: 'Enter the email or ID of the Google calendar you want to see. It must be shared with your account.',
      MODE_CREATE: 'Create new',
      MODE_SUBSCRIBE: 'Subscribe existing',
      CREATE_HINT: 'Create a NEW secondary calendar in your Google account (like Google’s "Create new calendar").',
      CREATE_PLACEHOLDER: 'Calendar name (e.g. North Office)',
      CREATE_ADD: 'Create',
      ADD_ERROR: 'Could not add the calendar. You may need to reconnect your Google Calendar to enable this feature.',
      FIELD_NAME: 'Name',
      FIELD_DESCRIPTION: 'Description',
      FIELD_DESCRIPTION_PLACEHOLDER: 'Calendar description (optional)',
      FIELD_TIMEZONE: 'Time zone',
      FIELD_TIMEZONE_DEFAULT: 'Account default',
      FIELD_COLOR: 'Color',
      EDIT_MODAL_TITLE: 'Edit calendar',
      EDIT_HINT: 'Edit the name, description, time zone and color of the calendar.',
      SAVE: 'Save',
    },
    AVAILABILITY: {
      TITLE: 'Team Availability',
      BUSY: 'Busy',
      FREE: 'Free',
      NOT_CONNECTED: 'No calendar',
    },
    CREATE_EVENT: {
      TITLE: 'Create Event',
      TYPE: {
        EVENT: 'Event',
        TASK: 'Task',
      },
      FIELDS: {
        CALENDAR: 'Calendar',
        CALENDAR_PRIMARY: 'Primary',
        SUMMARY: 'Title',
        SUMMARY_PLACEHOLDER: 'Event title',
        TASK_PLACEHOLDER: 'Task title',
        ALL_DAY: 'All day',
        START: 'Start',
        END: 'End',
        DUE_DATE: 'Due date',
        LOCATION: 'Location',
        LOCATION_PLACEHOLDER: 'Add location',
        DESCRIPTION: 'Description',
        DESCRIPTION_PLACEHOLDER: 'Event description (optional)',
        NOTES: 'Notes',
        NOTES_PLACEHOLDER: 'Add notes (optional)',
        ATTENDEES: 'Attendees',
        ATTENDEES_PLACEHOLDER: 'Type an email and press Enter',
      },
      SUBMIT: 'Create Event',
      SUBMIT_TASK: 'Create Task',
      CANCEL: 'Cancel',
      SUCCESS: 'Event created successfully',
      SUCCESS_TASK: 'Task created successfully',
      ERROR: 'Could not create. Please try again.',
    },
    EDIT_EVENT: {
      TITLE: 'Edit Event',
      SUBMIT: 'Save Changes',
      SUCCESS: 'Event updated successfully',
      ERROR: 'Could not update event. Please try again.',
    },
    CREATE_FROM_CONVERSATION: 'Create Calendar Event',
    SHARE_AGENDA: {
      TITLE: 'Send my agenda',
      DESCRIPTION: 'Choose the period and who to send the agenda to.',
      PERIOD: 'Period',
      TODAY: 'Today',
      DAYS_3: '3 days',
      DAYS_7: '7 days',
      INBOX: 'Send via',
      INBOX_PLACEHOLDER: 'Select a channel',
      CONTACTS: 'Contacts',
      CONTACTS_PLACEHOLDER: 'Search contact...',
      PREVIEW: 'Message preview',
      CANCEL: 'Cancel',
      SEND: 'Send',
      SUCCESS: 'Agenda sent successfully',
      ERROR: 'Could not send agenda. Please try again.',
    },
    API: {
      CONNECT_ERROR: 'Could not connect to Google Calendar',
      DISCONNECT_SUCCESS: 'Google Calendar disconnected',
      DISCONNECT_ERROR: 'Could not disconnect Google Calendar',
      FETCH_ERROR: 'Error loading calendar events',
    },
  },
};
